export const LOAD_CONFIG = 'LOAD_CONFIG';

export const loadConfig = (appConfig: string) => ({
  type: LOAD_CONFIG,
  payload: appConfig,
});
